export enum Associate{
  CHURCH = "church",
  COMMERCE = "commerce",
  MISSIONARY = "missionary",
  SERVICEPROVIDER = "service_provider",
  MUSICALARTIST = "musical_artist"
}
